import React from 'react'
import { Button, Form, Input, Row, Col, InputNumber } from 'antd';
import { useSelector, useDispatch } from 'react-redux'
import FormModal from "components/Modal/FormModal";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const InviteModal = ({ initialRecord }) => {



    const dispatch = useDispatch()
    const [form] = Form.useForm();



    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    const usersProps = useSelector(state => state.users)
    const { invite_Modal, initialValues, shouldClearForm, inviteUserLoader } = usersProps

    const { role } = userInfo
    console.log('======initialValues===========', initialValues)

    const renderPrice = () => {
        if (initialValues && initialValues.action === 'edit') {
            return ''
        }
        else {
            return <Row className="gx-d-flex  gx-flex-row">
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                        name="corporateAccountCharges"
                        label="Main MemberShip Charges"
                        rules={[{ required: true, message: 'Main MemberShip Charges required!' }]}

                    >
                        <InputNumber precision={2} formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} />
                    </Form.Item>



                </Col>

                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Form.Item
                        name="accountManagerCharges"
                        label="Per Seat Charges"
                        rules={[{ required: true, message: 'Per Seat Charges required!' }]}

                    >
                        <InputNumber precision={2} formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} />
                    </Form.Item>
                </Col>
            </Row>

        }
    }
    const getApiName = () => {
        if (initialValues && initialValues.action === 'changePricing') {
            return "updateSubscribePlan"
        }
        else {
            return "editUser"
        }

    }

    const getDisableValue = () => {
        if (initialValues) {
            if (initialValues.action === 'changePricing') {
                return true
            }
            if (initialValues.action === 'edit') {
                if (role === 'superAdmin' && initialValues.status === 'invited') {
                    return false
                }
                else {
                    return true
                }

            }
        }
        else {

            return false

        }


    }

    return (
        <div>
            <Button
                type="primary"
                className={`gx-pt-0`}
                onClick={() => {
                    dispatch({
                        type: 'Invite_Modal',
                        payload: null
                    })
                }}
            >
                Invite
            </Button>
            <FormModal
                modalTitle={!initialValues ? "Invite" : initialValues.action === 'changePricing' ? 'change price' : "Update"}
                basicButtonTitle="Sent Invitation"
                submitButtonText={initialValues === null ? "Add" : initialValues.action === 'changePricing' ? 'change price' : "Update"}
                cancelButtonText="Cancel"
                apiMethod="POST"
                apiName="inviteUser"
                apiLoaderName="invitingUser"
                editApiMethod="PUT"
                editApiName={getApiName()}
                confirmLoading={inviteUserLoader}
                ModalType="Invite_Modal"
                visible={invite_Modal}
                buttonStyleClass="gx-buttonStyleClass"
                isShowButton={false}
                initialValues={initialValues}
                initialRecord={initialRecord}
                form={form}
                width={600}
                shouldClearForm={shouldClearForm}

            >

                <Row className="gx-d-flex  gx-flex-row">
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="fullName"
                            label="Full Name"
                            rules={[{ required: true, message: 'Full name required!' }, {
                                pattern: new RegExp(/^[a-z, A-Z][a-z\s, A-Z\s]*$/),
                                message: "Only alphabets and spaces are allowed. space at start not allowed"
                            }]}
                        >
                            <Input disabled={initialValues && initialValues.action === 'changePricing' ? true : false} />
                        </Form.Item>



                    </Col>

                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="companyName"
                            label="Company Name"
                            rules={[{ required: true, message: 'Company name required!' }]}
                        >
                            <Input disabled={initialValues && initialValues.action === 'changePricing' ? true : false} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row className="gx-d-flex  gx-flex-row">
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="email"
                            label="Email"
                            rules={[{ required: true, type: 'email', message: 'Email required!' }]}
                            className="lower-case"
                        >
                            <Input disabled={getDisableValue()} />
                        </Form.Item>



                    </Col>

                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="phoneNumber"
                            label="Phone"
                            rules={[{ required: true, message: 'Company name required!' }]}
                        >
                            <PhoneInput
                                inputStyle={{
                                    width: '100%'
                                }}
                                country={'us'}
                                disabled={initialValues && initialValues.action === 'changePricing' ? true : false}
                                onChange={phone => form.setFieldsValue({ 'phoneNumber': phone })}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {renderPrice()}


                {/*                     <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="agentType"
                            label="Agent type"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter agent type!",
                                },
                            ]}

                        >
                            <Select className="gx-mb-2 gx-select-sm" placeholder="type of agent" style={{
                                minWidth: '200px'
                            }}>
                                <Option value="option1">Option1</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="assignRole"
                            label="Assign role"
                            rules={[
                                {
                                    required: true,
                                    message: "Please assign the role!",
                                },
                            ]}

                        >
                            <Select className="gx-mb-2 gx-select-sm" placeholder="assign role" >
                                <Option value="inspector">Inspector</Option>
                            </Select>
                        </Form.Item>
                    </Col> */}

                {/*                
                <Row className="gx-d-flex  gx-flex-row">
                    <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="transportType"
                            label="Transport Type"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input transport type!",
                                },
                            ]}

                        >
                            <Select className="gx-mb-2 gx-select-sm" placeholder="type of transport" style={{
                                minWidth: '200px'
                            }}>
                                <Option value="truck">Truck</Option>
                                <Option value="car">Car</Option>
                                <Option value="bicycle">Bicycle</Option>
                                <Option value="bicycle">Bike</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="licensePlate"
                            label="License plate"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input license plate!",
                                },
                            ]}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="color"
                            label="Color"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter the color!",
                                },
                            ]}

                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Form.Item
                            name="transPortDescription"
                            label="Transport description (year, model)"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input the transport description!",
                                },
                            ]}

                        >
                            <Input.TextArea rows="4" />
                        </Form.Item>
                    </Col>
                </Row> */}
            </FormModal>
        </div>

    )
}

export default InviteModal
